import * as React from "react";
import { SelectInput, Button, required } from "react-admin";
import { Container, Grid, Paper } from "@material-ui/core";
import { Form } from "react-final-form";
import SearchIcon from "@material-ui/icons/Search";
import { useState } from "react";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import appDataProvider from "../../../dataprovider";
import { ThyFleetTypes } from "../../../../src/Constants/Constant";
import { Add } from "@material-ui/icons";
import { ReliabilityReportType } from "../../../Enums/ReliabilityReportType";
import ReliabilityManualThyCreate from "../ManualCreate/ReliabilityManualThyCreate";

const ThyPrematureFailureFilter = ({ filterParams, setFilterParams }: any) => {
  const [acTypes, setAcTypes] = useState<any>([]);
  const [createOpen, setCreateOpen] = useState<boolean>(false);
  React.useEffect(() => {
    GetAcTypes();
  }, []);

  const GetAcTypes = () => {
    appDataProvider.http
      .get("cdmaircraft/FetchAcTypes")
      .then(response => {
        setAcTypes([...(response?.data?.items ?? [])]);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const onSubmit = values => {
    setFilterParams(values);
  };
  const onCloseCreate = () => {
    setCreateOpen(false);
  };
  const onOpenCreate = e => {
    setCreateOpen(true);
  };

  return (
    <Container maxWidth="xl">
      <ReliabilityManualThyCreate
        isOpen={createOpen}
        onClose={onCloseCreate}
        reportType={ReliabilityReportType.ThyPrematureFailure}
      />
      <Form
        onSubmit={onSubmit}
        initialValues={filterParams}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Paper style={{ padding: 10 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <SelectInput
                    source="acType"
                    optionValue="acType"
                    optionText="acType"
                    fullWidth
                    variant="outlined"
                    choices={acTypes}
                    label="Ac Type"
                    allowEmpty
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectInput
                    source="fleetType"
                    optionValue="type"
                    optionText="value"
                    fullWidth
                    variant="outlined"
                    choices={ThyFleetTypes}
                    label="Fleet Type"
                    allowEmpty
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <CustomDatetime
                    source="startDate"
                    fullWidth
                    variant="outlined"
                    label="Start Date"
                    validate={required()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <CustomDatetime
                    source="endDate"
                    fullWidth
                    variant="outlined"
                    label="End Date"
                    validate={required()}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    label="Search"
                    size="large"
                    startIcon={<SearchIcon />}
                    style={{ marginTop: 6 }}
                  />
                  <Button
                    onClick={onOpenCreate}
                    variant="contained"
                    color="primary"
                    disabled={submitting}
                    label="Create"
                    size="large"
                    startIcon={<Add />}
                    style={{ marginTop: 6, marginLeft: 5 }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </form>
        )}
      />
    </Container>
  );
};

export default ThyPrematureFailureFilter;
